import { nullish, object, pipe, transform, url } from 'valibot'
import {
  imagesData,
  richTextData,
  singleImage,
  singleLineData,
} from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'

const urlSchema = pipe(singleLineData, url())

export const podcastSchema = crystallizeDocumentSchema(
  'podcast',
  object({
    title: nullish(singleLineData),
    description: nullish(richTextData),
    headerImage: nullish(imagesData),
    coverImage: singleImage,
    providers: pipe(
      safeArray(object({
        acast: urlSchema,
        spotify: nullish(urlSchema),
        apple: nullish(urlSchema),
      })),
      transform(it => it?.[0]),
    ),
  }),
)
